import React from 'react'
import Navbar from './Navbar';

const Thanks = () => {
    return (
        <div className="make-test">
            <Navbar />

            <div className="container">
          <div className="row p-5 text-center">
            <div className="col">
              <img
                src={"dragonfly.png"}
                className="card-img-top w-25"
                alt="The Healing Colors"
              ></img>              
              <h1 className="text-light mt-5">Thanks for using The Healing Colors</h1>              
            </div>             
          </div>
          </div>

            
        </div>
    )
}

export default Thanks
